import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ProviderDeliveryAddressLabelGenerator from "./components/ProviderDeliveryAddressLabelGenerator";

const ProviderDeliveryAddressLabelPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const initialRows = Array.isArray(location.state?.rows)
    ? location.state.rows.map((row) => ({ ...row }))
    : [];
  const initialProviderCodes = String(location.state?.providerCodes ?? "");
  const initialStatus = String(
    location.state?.status ??
      (initialRows.length > 0
        ? `Loaded ${initialRows.length} label${initialRows.length > 1 ? "s" : ""}.`
        : "")
  );
  const initialFromContactNumber = String(
    location.state?.fromContactNumber ?? ""
  );

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="mb-6 flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">
            Provider Delivery Address Label Generation
          </h1>
          <p className="text-sm text-gray-600">
            Load provider codes, review/edit details, then print labels.
          </p>
        </div>
        <button
          onClick={() => navigate("/settlement-list")}
          className="inline-flex items-center gap-2 px-3 py-1.5 text-sm border rounded hover:bg-gray-100"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          Back to Settlement List
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden">
        <ProviderDeliveryAddressLabelGenerator
          initialProviderCodes={initialProviderCodes}
          initialRows={initialRows}
          initialStatus={initialStatus}
          initialFromContactNumber={initialFromContactNumber}
        />
      </div>
    </div>
  );
};

export default ProviderDeliveryAddressLabelPage;
